module.exports = __webpack_public_path__ + "static/60d75c9e6e56f164ce0461df6b31e6dc82c9b3d70b2ca036411d66a80a4cbea4-c898369d1a2ca4c0169a0ea35166b7fe.png";